/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItDataTypeDto } from './TrackItDataTypeDto';
import {
    TrackItDataTypeDtoFromJSON,
    TrackItDataTypeDtoFromJSONTyped,
    TrackItDataTypeDtoToJSON,
} from './TrackItDataTypeDto';
import type { TrackItMeasurementParameterDto } from './TrackItMeasurementParameterDto';
import {
    TrackItMeasurementParameterDtoFromJSON,
    TrackItMeasurementParameterDtoFromJSONTyped,
    TrackItMeasurementParameterDtoToJSON,
} from './TrackItMeasurementParameterDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface TrackItMeasurementInfoDto
 */
export interface TrackItMeasurementInfoDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    measurementDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    importDate?: string;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof TrackItMeasurementInfoDto
     */
    importUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    radiationUnit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    measurementDevice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    measurementSoftware?: string | null;
    /**
     * 
     * @type {Array<TrackItMeasurementParameterDto>}
     * @memberof TrackItMeasurementInfoDto
     */
    measurementParameters?: Array<TrackItMeasurementParameterDto> | null;
    /**
     * 
     * @type {Array<TrackItDataTypeDto>}
     * @memberof TrackItMeasurementInfoDto
     */
    dataTypes?: Array<TrackItDataTypeDto> | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItMeasurementInfoDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementInfoDto
     */
    readonly commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    readonly lastComment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementInfoDto
     */
    $type?: TrackItMeasurementInfoDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementInfoDtoTypeEnum = typeof TrackItMeasurementInfoDtoTypeEnum[keyof typeof TrackItMeasurementInfoDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementInfoDto interface.
 */
export function instanceOfTrackItMeasurementInfoDto(value?: unknown): value is TrackItMeasurementInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementInfoDtoTypeEnum)[0];
}

export function TrackItMeasurementInfoDtoFromJSON(json: any): TrackItMeasurementInfoDto {
    return TrackItMeasurementInfoDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'measurementDate': json['measurementDate'] == null ? undefined : json['measurementDate'],
        'importDate': json['importDate'] == null ? undefined : json['importDate'],
        'importUser': json['importUser'] == null ? undefined : HistoryDtoUserFromJSON(json['importUser']),
        'radiationUnit': json['radiationUnit'] == null ? undefined : json['radiationUnit'],
        'measurementDevice': json['measurementDevice'] == null ? undefined : json['measurementDevice'],
        'measurementSoftware': json['measurementSoftware'] == null ? undefined : json['measurementSoftware'],
        'measurementParameters': json['measurementParameters'] == null ? undefined : ((json['measurementParameters'] as Array<any>).map(TrackItMeasurementParameterDtoFromJSON)),
        'dataTypes': json['dataTypes'] == null ? undefined : ((json['dataTypes'] as Array<any>).map(TrackItDataTypeDtoFromJSON)),
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementInfoDtoToJSON(value?: Omit<TrackItMeasurementInfoDto, 'commentCount'|'lastComment'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'measurementDate': value['measurementDate'],
        'importDate': value['importDate'],
        'importUser': HistoryDtoUserToJSON(value['importUser']),
        'radiationUnit': value['radiationUnit'],
        'measurementDevice': value['measurementDevice'],
        'measurementSoftware': value['measurementSoftware'],
        'measurementParameters': value['measurementParameters'] == null ? undefined : ((value['measurementParameters'] as Array<any>).map(TrackItMeasurementParameterDtoToJSON)),
        'dataTypes': value['dataTypes'] == null ? undefined : ((value['dataTypes'] as Array<any>).map(TrackItDataTypeDtoToJSON)),
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        '$type': value['$type'],
    });
}

